import { Box, Divider, Grid, Typography, Alert } from '@mui/material';
import HeaderBreadcrumb from '../shared-components/HeaderBreadcrumb';
import { CompanySelection, GeneralInformationSelection, GroupSelection, YearSelection } from '../shared-components/SelectionButtons';
import AssetList from '../categories/category-one/add-assets/AssetList';
import SupplierList from '../categories/category-one/add-assets/SupplierList';
import PetrolCardHolderList from '../categories/category-one/add-assets/PetrolCardHolderList';
import IntensityMetrics from '../categories/category-one/add-assets/IntensityMetrics';
import EmployeeCommuting from '../categories/category-one/add-assets/EmployeeCommuting';
import CultivationPlotList from '../categories/category-one/add-assets/CultivationPlotList';
import CultivationAgroChemicals from '../categories/category-one/add-assets/CultivationAgroChemicals';
import CultivationFertiliser from '../categories/category-one/add-assets/CultivationFertiliser';
import useButtonSelection from '../hooks/button-selection-hooks';

export default function GeneralInformation({ variant, company, years, groups }) {
    const {
        selectedYear,
        selectedCompany,
        selectedGroup,
        generalInformationOptions,
        selectedGeneralInformationOption,
        handleOnClick } = useButtonSelection(variant, company, years, groups)

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <HeaderBreadcrumb variant={variant} year={selectedYear} company={selectedCompany} group={selectedGroup}
                generalInformationOption={selectedGeneralInformationOption} />
            <Grid container item spacing={0} xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2 }}>
                <YearSelection years={years} selectedYear={selectedYear} handleOnClick={handleOnClick} />
                {selectedYear &&
                    <CompanySelection company={company} selectedCompany={selectedCompany} handleOnClick={handleOnClick} />}
                {selectedCompany &&
                    <GroupSelection groups={groups} selectedGroup={selectedGroup} handleOnClick={handleOnClick} />}
                {selectedGroup &&
                    <GeneralInformationSelection
                        generalInformationOptions={generalInformationOptions}
                        selectedGeneralInformationOption={selectedGeneralInformationOption}
                        handleOnClick={handleOnClick} />}
            </Grid>
            {
                selectedGeneralInformationOption &&
                <GeneralInformationTable generalInformationOption={selectedGeneralInformationOption}
                    year={selectedYear} companyId={selectedCompany.id} groupId={selectedGroup.id} />
            }
        </Box>
    )
}

function GeneralInformationTable({ generalInformationOption, year, companyId, groupId }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Divider />
                <Typography variant='h5' >
                    {generalInformationOption}
                </Typography>
                {/* if the generalInformationOption is fertilizerlist agrochemicallist or plotlist add an alert to state that it is a global data input category */}
                {(generalInformationOption === 'Fertilizer List' || generalInformationOption === 'Agrochemical List' || generalInformationOption === 'Plot List') &&
                    <Alert severity='info' sx={{ width: 'fit-content' }}>
                        {`Note: The ${generalInformationOption} data input category applies to all years.`}
                    </Alert>
                }
            </Box>
            {generalInformationOption === 'Asset List' &&
                <AssetList year={year} companyId={companyId} groupId={groupId} />}
            {generalInformationOption === 'Supplier List' &&
                <SupplierList year={year} companyId={companyId} groupId={groupId} />}
            {generalInformationOption === 'Petrol Card Holder List' &&
                <PetrolCardHolderList year={year} companyId={companyId} groupId={groupId} />}
            {generalInformationOption === 'Intensity Metrics' &&
                <IntensityMetrics year={year} groupId={groupId} />}
            {generalInformationOption === 'Employee Commuting' &&
                <EmployeeCommuting year={year} groupId={groupId} />}
            {generalInformationOption === 'Plot List' &&
                <CultivationPlotList year={year} groupId={groupId} />}
            {generalInformationOption === 'Agrochemical List' &&
                <CultivationAgroChemicals year={year} groupId={groupId} />}
            {generalInformationOption === 'Fertilizer List' &&
                <CultivationFertiliser year={year} groupId={groupId} />}
        </Box>
    )
}